// Get RPC endpoints from environment variables
const getDroppChainNodes = () => {
  const endpoint =
    process.env.REACT_APP_DROPPCHAIN_ENDPOINT || "ws://127.0.0.1:9944";
  return [{ name: "REGAChain", url: endpoint }];
};

const getDroppBCBNodes = () => {
  const endpoint =
    process.env.REACT_APP_DROPPBCB_ENDPOINT || "ws://127.0.0.1:9945";
  return [{ name: "DroppBCB", url: endpoint }];
};

const droppchain = {
  name: "droppChain",
  identity: "droppchain",
  sub: "droppchain",
  value: "droppchain",
  chain: "droppchain",
  symbol: "DROPP",
  decimals: 12,
  chainIcon: "originalPolkadot", // Using default icon for now
  color: "#00A786", // Seaweed - Primary brand color
  buttonColor: "#00868A", // Dark Cyan - Button color
  modules: {
    identity: false,
    multisig: false,
    vestings: false,
    proxy: false,
    // Custom optimistic rollup modules
    checkpoint: true,
    bcb: true,
    did: true, // Enable DID module
  },
  nodes: getDroppChainNodes(),
  useOnChainBlockData: true,
  // Optimistic rollup specific
  isOptimisticRollup: true,
  validatorChain: "droppbcb",
  validatorNodes: getDroppBCBNodes(),
};

export default droppchain;
